import { h } from '@stencil/core';
export class ProductSelectorModal {
  constructor() {
    this.handleCloseButtonClick = () => {
      this.didClose.emit();
    };
    this.headerLabel = undefined;
    this.open = false;
    this.isFullscreen = false;
  }
  handleFullscreenToggle() {
    this.isFullscreen = !this.isFullscreen;
    if (this.isFullscreen) {
      this.setFullscreenStyles();
    }
    else {
      this.setDefaultStyles();
    }
  }
  isMobile() {
    return window.innerWidth <= 980;
  }
  setDefaultStyles() {
    const innerContent = this.element
      .querySelector('se-dialog-content')
      .shadowRoot.querySelector('.se-dialog-content');
    innerContent.style.padding = '5px 20px 20px 20px';
    innerContent.style.alignItems = 'stretch';
    const innerContentMarginDiv = innerContent.querySelector('.inner-content');
    innerContentMarginDiv.style.margin = '0';
    const quartzModalBackdropElement = this.element
      .querySelector('se-dialog')
      .shadowRoot.querySelector('.dialog-background');
    quartzModalBackdropElement.style.backgroundColor = 'rgba(0,0,0,.4)';
    const quartzModalContainer = this.element
      .querySelector('se-dialog')
      .shadowRoot.querySelector('.dialog');
    quartzModalContainer.style.height = '80%';
    quartzModalContainer.style.width = '80%';
    const quartzModalDialogBodyInner = this.element
      .querySelector('se-dialog')
      .shadowRoot.querySelector('.dialog-body-inner');
    quartzModalDialogBodyInner.style.height = '100%';
  }
  setMobileOffset() {
    const quartzModalContainer = this.element
      .querySelector('se-dialog')
      .shadowRoot.querySelector('.dialog-wrapper');
    quartzModalContainer.style.margin = '5px';
    const innerContent = this.element
      .querySelector('se-dialog-content')
      .shadowRoot.querySelector('.se-dialog-content');
    innerContent.style.padding = '5px 0 0 0';
  }
  setFullscreenStyles() {
    const dialog = this.element
      .querySelector('se-dialog')
      .shadowRoot.querySelector('.dialog');
    dialog.style.height = '100%';
    dialog.style.width = '100%';
  }
  getSize() {
    if (this.isFullscreen || this.isMobile()) {
      return 'fill';
    }
    return 'large';
  }
  renderFullscreenControls() {
    return h("expand-button", { isFullscreen: this.isFullscreen });
  }
  renderCloseModalControls() {
    return (h("button", { type: "button", class: "button-close", onClick: this.handleCloseButtonClick }, h("div", { class: "icon-close" })));
  }
  componentDidLoad() {
    this.setDefaultStyles();
    if (this.isMobile()) {
      this.setFullscreenStyles();
      this.setMobileOffset();
    }
  }
  render() {
    return (h("se-dialog", { size: this.getSize(), open: this.open, noBackdrop: "true" }, h("div", { class: "sc-selector-modal-header" }, h("h1", { class: "header-label", innerHTML: this.headerLabel }), h("div", { class: "sc-selector-modal-controls" }, this.renderFullscreenControls(), this.renderCloseModalControls())), h("se-dialog-content", null, h("slot", null))));
  }
  static get is() { return "pdp-sc-selector-modal"; }
  static get originalStyleUrls() {
    return {
      "$": ["product-selector-modal.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["product-selector-modal.css"]
    };
  }
  static get properties() {
    return {
      "headerLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Main header text"
        },
        "attribute": "header-label",
        "reflect": false
      },
      "open": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Is modal open (true/false)"
        },
        "attribute": "open",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get states() {
    return {
      "isFullscreen": {}
    };
  }
  static get events() {
    return [{
        "method": "didClose",
        "name": "didClose",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": "Closing modal event that needs to be handled by the consumer\nof the window, typically for unmounting from DOM"
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get elementRef() { return "element"; }
  static get listeners() {
    return [{
        "name": "expandModal",
        "method": "handleFullscreenToggle",
        "target": undefined,
        "capture": false,
        "passive": false
      }];
  }
}
